import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  compareSizes,
  convertCase,
  formatSize,
  getImagePath,
  getUniqueFilteredData,
  mapDeliveryType,
  parseSize,
} from "../../../SharedFiles/Helper/utils";
import { GetItemByGrp } from "../../../APIServices/SalesService/OrderService/OrderThunk";
import { FaChevronRight } from "react-icons/fa6";

const ItemGroupDiv = ({ setInProgress, InProgress }) => {
  const dispatch = useDispatch();
  const { ItemGroup, error, loading } = useSelector((state) => state.order);
  const groupedByType =
    ItemGroup &&
    ItemGroup.length > 0 &&
    ItemGroup.reduce((acc, item) => {
      const { deliverY_TYPE, iteM_SIZE } = item;
      const key = String(deliverY_TYPE).trim();
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(iteM_SIZE);

      return acc;
    }, {});

  const handleItemGrp = (size, groupedSizes) => {
    const dataToStore = {
      size: size,
      groupedSizes: groupedSizes,
    };
    sessionStorage.setItem("itemGroup", JSON.stringify(dataToStore));
    const mappedDeliveryType = mapDeliveryType(groupedSizes);
    setInProgress({ ...InProgress, FetchItem: true });
    dispatch(GetItemByGrp({ ItemSize: size, Delivery: mappedDeliveryType }));
  };
  const customOrder = ["GI_Pipes", "GI_SmallBox", "GI_BigBox", "GI_Purlin"];
  return (
    // <div className="groupitem">
    //     {groupedByType && Object.keys(groupedByType).length > 0 &&  (
    //         Object.keys(groupedByType).map((type, index) => (
    //             <div key={index} className="grpDiv">
    //                 <h3>{convertCase(type)}</h3>
    //                 
    //                 <ul className="lineborder">
    //                     {groupedByType[type].map((size, subIndex) => (
    //                         <div key={subIndex} className="lineDiv">
    //                             <span className="image-div">
    //                                 <img
    //                                     src={getImagePath(type)}
    //                                     alt={type}
    //                                     className="group-image"
    //                                 />
    //                             </span>
    //                             <li className="groupSize" onClick={() => handleItemGrp(size, type)} key={subIndex}>{formatSize(size)}
    //                                 <FaChevronRight size={14} className="RightIcon" />
    //                             </li>
    //                         </div>
    //                     ))}
    //                 </ul>
    //             </div>
    //         ))
    //     ) }
    // </div>
    <div className="groupitem">
      {groupedByType &&
        Object.keys(groupedByType).length > 0 &&
        customOrder
          .filter((type) => groupedByType[type])
          .map((type, index) => (
            <div key={index} className="grpDiv">
              <h3>{convertCase(type)}</h3>
              <ul className="lineborder">
              {groupedByType[type].slice().sort(compareSizes)
                  .map((size, subIndex) => (
                    <div key={subIndex} className="lineDiv">
                      <span className="image-div">
                        <img
                          src={getImagePath(type)}
                          alt={type}
                          className="group-image"
                        />
                      </span>
                      <li
                        className="groupSize"
                        onClick={() => handleItemGrp(size, type)}
                      >
                        {formatSize(size)}
                        <FaChevronRight size={14} className="RightIcon" />
                      </li>
                    </div>
                  ))}
              </ul>
            </div>
          ))}
    </div>
  );
};

export default ItemGroupDiv;
